import React, {  useEffect } from 'react';
import { Table, Input, Select } from 'antd';
import "./Table.css"
import moment from 'moment';
import { IoPersonRemoveSharp } from "react-icons/io5";
import { MdOutlineAssignment } from "react-icons/md";

function DataTable({ data, onClickAssign, setActiveCasetData, toggleAddReadingModal }: any) {
    const columns: any= [
        { 
          title: '#', 
          dataIndex: 'index', 
          key: 'index',
          render: (text: any, record: any, index: number) => index + 1,
        },
        {
          title: 'Name', 
          dataIndex: 'name', 
          key: 'name',
        },
        {
          title: 'Name French', 
          dataIndex: 'name_french', 
          key: 'name_french',
        },
        {
          title: 'Description', 
          dataIndex: 'description', 
          key: 'description',
        },
        {
          title: 'Description French', 
          dataIndex: 'description_french', 
          key: 'description_french',
        },
        {
          title: 'Enabled',
          dataIndex: 'enabled',
          key: 'enabled',
          render: (enabled: any) => (enabled ? `True` : 'False')
        },
          {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
            render: (price: any) => (price ? `${price} CFA` : '---')
          },
          {
            title: "Action",
            dataIndex: "action",
            key: "action",
            render: (_: any, record: any) => (
              <td>
        
            <i
                  style={{ position: "relative", top: 3, cursor: "pointer" }}
                  onClick={() => {
                    // ASSIGN FEATURE
                    // console.log(record)
                    onClickAssign(record?.id)
                  }}
                >
                  <MdOutlineAssignment
                    style={{
                      backgroundColor: "#4F5052",
                      padding: 5,
                      borderRadius: 5,
                      color: "white",
                      marginRight: 15,
                    }}
                    size={30}
                  />
                </i>
              </td>
            ),
          },
      ];
  
      

    return (
        <Table
            columns={columns}
            // expandable={{ expandedRowRender, defaultExpandedRowKeys: ['0'] }}
            dataSource={data.map((item: any, index: any) => ({ ...item, index: index + 1 }))}
      />
    );
}

export default DataTable;